import React from "react";
import { Icon, StatusBadge, Text } from "@zorni/components-lib";

import { RESERVATION_STATUS } from "../../../common/model/enum";
import { useReservationDateDisplayValue } from "../hooks/useReservationDateDisplayValue";

import styles from "./TripReservationTable.module.css";

const formatReferenceBadge = (reference) => {
  if (!reference) return "-";
  const clean = String(reference).startsWith("#")
    ? String(reference).slice(1)
    : String(reference);
  return `#${clean}`;
};

const mapReservationStatusToBadge = (status) => {
  if (status === RESERVATION_STATUS.CONFIRMED) {
    return { label: "Confirmée", type: "active", iconName: "iconCheck" };
  }
 if (
    status === RESERVATION_STATUS.CREATED
  ) {
    return { label: "Créée", type: "pending", iconName: "iconBell" };
  }

  if (
    status === RESERVATION_STATUS.IN_PROGRESS
  ) {
    return { label: "En attente", type: "pending", iconName: "iconWarning" };
  }

  if (status === RESERVATION_STATUS.CANCELED) {
    return { label: "Annulée", type: "suspended", iconName: "iconClose" };
  }

  if (status === RESERVATION_STATUS.ARCHIVED) {
    return { label: "Archivée", type: "inactive", iconName: "iconFile" };
  }

  if (status === RESERVATION_STATUS.PASSED) {
    return { label: "Passée", type: "inactive", iconName: "iconPlugs" };
  }

  return { label: "-", type: "inactive", iconName: "iconPlugs" };
};

const TripReservationTable = ({ reservations }) => {
  const formatDateDisplayValue = useReservationDateDisplayValue();

  if (!reservations.length) {
    return (
      <div className={styles.emptyState}>
        <Text size="sm" color="muted">
          Aucune réservation à afficher.
        </Text>
      </div>
    );
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th>Booking Ref</th>
            <th>Réf voyage</th>
            <th>Etablissement</th>
            <th>Date</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {reservations.map((item) => {
            const status = mapReservationStatusToBadge(item.status);
            const startDate = item?.tripDate?.startDate || "-";
            const endDate = item?.tripDate?.endDate || "-";
            const displayValue = formatDateDisplayValue(startDate, endDate);

            return (
              <tr key={item.id}>
                <td>
                  <span className={styles.referenceBadge}>
                    {formatReferenceBadge(item?.id)}
                  </span>
                </td>
                <td>
                  <span className={styles.referenceBadge}>
                    {formatReferenceBadge(item?.tripPublicationResume?.trip?.reference)}
                  </span>
                </td>
                <td>{item?.tripPublicationResume?.trip?.establishment?.company?.legalName || "-"}</td>
                <td>
                  <div className={styles.dateCell}>
                    <Icon name="iconCalendar" size="sm" />
                    <span>{displayValue}</span>
                  </div>
                </td>
                <td>
                  <StatusBadge
                    iconName={status.iconName}
                    iconPosition="left"
                    label={status.label}
                    type={status.type}
                    size="small"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TripReservationTable;
